import { useEffect, useState, useCallback, memo } from "react";
import { useCalendarStore, useForm } from "../../hooks";
import {
  SelectForm,
  InputForm,
  TextAreaForm,
  LoadingData,
  ErrorMessage,
  MainButton,
  SecondaryButton,
} from "../ui";
import { useFormMessages } from "../hooks";

const initialFormData = {
  protocolId: "",
  numberEvents: "",
};

const initialFormValidations = {
  protocolId: [(value) => value.length > 0, "Selecciona un protocolo"],
  numberEvents: [(value) => value.length > 0, "Asigna un número de eventos"],
};

export const ValorationPatientScheduledAssessment = ({
  patientSurgeryId,
  scheduleEventId,
  procedure,
}) => {
  // Datos del hook ----------------------------------------//
  const {
    //Props
    message,
    isLoading,

    //Methods
    startGetProtocols,
    startUpdatePatientSurgeryByAssessmentMade,
    startUpdatePatientSurgeryByNoPresentAssessment,
  } = useCalendarStore();

  const isSedacionPreAnestesia =
    procedure.id === "78763555-39b4-4433-a7f2-079dea69b64a" ||
    procedure.id === "3d44fc12-6947-42c8-aaec-49b2fca42681";

  // States ------------------------------------------------//
  const [protocols, setProtocols] = useState([]);
  const [validateForm, setValidateForm] = useState(false);
  const [formData, setFormData] = useState({
    ...initialFormData,
    patientSurgeryId,
    scheduleEventId,
  });
  const [formValidations, setFormValidations] = useState(
    initialFormValidations
  );

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid, onResetForm } =
    useForm(formData, formValidations);

  const {
    setFormSubmitted,
    showErrorMessage,
    showSuccessMessage,
    messageText,
  } = useFormMessages({
    message,
    setValidateForm,
  });

  // Funciones ---------------------------------------------//
  const getProtocols = useCallback(async () => {
    const response = await startGetProtocols();

    if (Array.isArray(response)) {
      return setProtocols(response);
    }
  }, []);

  const protocolIdChange = (event) => {
    const { name, value } = event.target;

    const protocol = protocols.find((protocol) => protocol.id === value)?.text;

    setFormData(() => {
      const updated = {
        ...formState,
        [name]: value,
        protocol,
      };

      return updated;
    });

    setFormValidations(() => {
      const updated = {
        ...formValidations,
        protocol: [
          (val) => (val ?? "").toString().trim().length > 0,
          "Escribe un protocolo",
        ],
      };

      return updated;
    });
  };

  const clearanceStatusChange = (event) => {
    const { name, value } = event.target;

    setFormData(() => {
      const updated = {
        ...formState,
        [name]: value,
      };

      if (value === "NO_BUT_CAN_RESCHEDULE" || value === "NO") {
        updated.clearanceNote = "";
        updated.numberEvents = 0;
      } else {
        delete updated.clearanceNote;
        updated.numberEvents = 1;
      }

      return updated;
    });

    setFormValidations(() => {
      const updated = {
        ...formValidations,
      };

      if (value === "NO_BUT_CAN_RESCHEDULE" || value === "NO") {
        updated.clearanceNote = [
          (val) => (val ?? "").toString().trim().length > 0,
          "Escribe el motivo",
        ];
      } else {
        delete updated.clearanceNote;
      }

      return updated;
    });
  };

  const onSendValoration = () => {
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startUpdatePatientSurgeryByAssessmentMade(formState);
    }
  };

  const onPatientNoPresent = () => {
    setFormSubmitted(true);
    startUpdatePatientSurgeryByNoPresentAssessment(
      patientSurgeryId,
      scheduleEventId
    );
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (protocols.length === 0) {
      getProtocols();
    }
  }, [protocols.length, getProtocols]);

  useEffect(() => {
    if (procedure) {
      if (
        procedure.id === "78763555-39b4-4433-a7f2-079dea69b64a" ||
        procedure.id === "3d44fc12-6947-42c8-aaec-49b2fca42681"
      ) {
        setFormData(() => {
          const updated = {
            ...formState,
            clearanceStatus: "",
            numberEvents: 1,
          };

          return updated;
        });

        setFormValidations(() => {
          const updated = {
            ...formValidations,
            clearanceStatus: [
              (val) => (val ?? "").toString().trim().length > 0,
              "Selecciona una opción",
            ],
          };

          delete updated.numberEvents;

          return updated;
        });
      }
    }
  }, [procedure]);

  // useEffect(() => {
  //   console.log(formState);
  // }, [formState]);

  // useEffect(() => {
  //   console.log(formValidation);
  // }, [formValidation]);

  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="row g-3">
            {/* Formulario estatico */}
            <>
              <div className="col-md-12">
                <SelectForm
                  label={"Selecciona el protocolo"}
                  options={protocols}
                  labelKey={"name"}
                  validation={formValidation.protocolIdValid}
                  submit={validateForm}
                  name={"protocolId"}
                  value={formState.protocolId}
                  onInputChange={protocolIdChange}
                />
              </div>

              {formState.protocolId && (
                <div className="col-md-12">
                  <TextAreaForm
                    label={"Protocolo"}
                    placeholder={"Protocolo"}
                    validation={formValidation.protocolValid}
                    submit={validateForm}
                    name={"protocol"}
                    value={formState.protocol}
                    onInputChange={onInputChange}
                  />
                </div>
              )}

              {isSedacionPreAnestesia ? (
                <div className="col-md-12">
                  <label className="form-label">
                    {"¿Está autorizado para procedimiento?"}
                  </label>
                  <div className="custom-control custom-radio custom-control-inline">
                    <div className="form-check mb-0">
                      <input
                        id="clearanceStatus-YES"
                        className="form-check-input me-2"
                        readOnly
                        type="radio"
                        name={`clearanceStatus`}
                        value={"YES"}
                        checked={formState.clearanceStatus === "YES"}
                        onChange={clearanceStatusChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="clearanceStatus-YES"
                      >
                        Sí
                      </label>
                    </div>
                    <div className="form-check mb-0">
                      <input
                        id="clearanceStatus-NO_BUT_CAN_RESCHEDULE"
                        className="form-check-input me-2"
                        readOnly
                        type="radio"
                        name={`clearanceStatus`}
                        value={"NO_BUT_CAN_RESCHEDULE"}
                        checked={
                          formState.clearanceStatus === "NO_BUT_CAN_RESCHEDULE"
                        }
                        onChange={clearanceStatusChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="clearanceStatus-NO_BUT_CAN_RESCHEDULE"
                      >
                        No, pero puede reprogramar
                      </label>
                    </div>
                    {formState.clearanceStatus === "NO_BUT_CAN_RESCHEDULE" && (
                      <div className="mb-2">
                        <TextAreaForm
                          placeholder={
                            "Describe el motivo por el cual el paciente puede reprogramar"
                          }
                          validation={formValidation.clearanceNoteValid}
                          submit={validateForm}
                          name={"clearanceNote"}
                          value={formState.clearanceNote}
                          onInputChange={onInputChange}
                          rows={2}
                        />
                      </div>
                    )}
                    <div className="form-check mb-0">
                      <input
                        id="clearanceStatus-NO"
                        className="form-check-input me-2"
                        readOnly
                        type="radio"
                        name={`clearanceStatus`}
                        value={"NO"}
                        checked={formState.clearanceStatus === "NO"}
                        onChange={clearanceStatusChange}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="clearanceStatus-NO"
                      >
                        No
                      </label>
                    </div>
                    {formState.clearanceStatus === "NO" && (
                      <div className="mb-2">
                        <TextAreaForm
                          placeholder={
                            "Describe el motivo por el cual el paciente no está autorizado para el procedimiento"
                          }
                          validation={formValidation.clearanceNoteValid}
                          submit={validateForm}
                          name={"clearanceNote"}
                          value={formState.clearanceNote}
                          onInputChange={onInputChange}
                          rows={2}
                        />
                      </div>
                    )}
                  </div>
                  {formValidation.clearanceStatusValid && validateForm && (
                    <span className="text-danger">
                      {formValidation.clearanceStatusValid}
                    </span>
                  )}
                </div>
              ) : (
                <div className="col-md-12">
                  <InputForm
                    label={"Número de eventos"}
                    type={"number"}
                    placeholder={"Número de eventos"}
                    validation={formValidation.numberEventsValid}
                    submit={validateForm}
                    name={"numberEvents"}
                    value={formState.numberEvents}
                    onInputChange={onInputChange}
                  />
                </div>
              )}
            </>
            {/* Mensajes */}
            <>
              {isLoading && (
                <div className="col-md-12">
                  <LoadingData />
                </div>
              )}
              {showErrorMessage && (
                <div className="col-md-12">
                  <ErrorMessage>{messageText}</ErrorMessage>
                </div>
              )}
            </>
            <div className="col-md-12 d-flex justify-content-end">
              <SecondaryButton
                type={"button"}
                onClick={() => onPatientNoPresent()}
                disabled={isLoading}
              >
                No asistió
              </SecondaryButton>
              <MainButton
                className={"ms-2"}
                type={"button"}
                onClick={() => onSendValoration()}
                disabled={isLoading}
              >
                Valorar
              </MainButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
